import React, { useState } from 'react'
import KZone from './PointMarkerBkg/bg_ticked_zone.png'
import TM from './PointMarkerBkg/bg_TM.jpg'
import XC from './PointMarkerBkg/bg_XC.jpg'
import TY from './PointMarkerBkg/bg_TY.jpg'
import TC from './PointMarkerBkg/bg_TC.jpg'
import DL from './PointMarkerBkg/bg_DL.jpg'
import TN from './PointMarkerBkg/bg_TN.jpg'
import CCL from './PointMarkerBkg/bg_CCL.jpg'
import DefaultField from './PointMarkerBkg/bg_default.jpg'

const Point = ({top, left, hidden, radius, color}) => {
  const styleConfig = {
    top: top, 
    left: left, 
    width: `${radius}px`, 
    height: `${radius}px`,
    backgroundColor: color 
  }
  return <div className="marker-point" style={styleConfig} hidden={hidden} />
}

const StadiumBackgroundMap = {
  '天母棒球場': TM,
  '新莊棒球場': XC,
  '桃園國際棒球場': TY,
  '台中洲際棒球場': TC,
  '斗六棒球場': DL,
  '台南市立棒球場': TN,
  '澄清湖棒球場': CCL,
  others: DefaultField,
}



export const PointMarker = ({background, initX=null, initY=null, dotColor='rgba(255,16,16, 1)', field='others', handleOnChange}) => {
  const width = background==='plate'? 360 : 640
  const bkg = background==='plate'? KZone:(StadiumBackgroundMap[field]===undefined? DefaultField:StadiumBackgroundMap[field])
  const pointSize = background==='plate'? 12 : 4
  const height = background==='plate'? width*8/9 : width*3/4
  const xunit = background==='plate'? 360 : 640
  const inputLoc2markerLoc = (ix, iy) => {
    if (ix === null || iy === null) return [null, null]
    ix = parseFloat(ix)
    iy = parseFloat(iy)
    if (isNaN(ix) || isNaN(iy)) return [null, null]
    let tx, ty
    if (background === 'plate') {
      tx = (ix + 805 / 18) / (0.257)
      ty = (iy - 8345 / 115) / (-0.252)
    } else {
      tx = (ix + 37700 / 95) / (1.256)
      ty = (iy - 237000 / 473) / (-1.2685)
    }

    return [tx, ty]
  }
  const [x, setX] = useState(inputLoc2markerLoc(initX, initY)[0])
  const [y, setY] = useState(inputLoc2markerLoc(initX, initY)[1])
  const [hidden, setHidden] = useState((initX===null||initX==='')? true:false)
  const markerLoc2StandardLoc = (lx, ly) => {
    let tx, ty
    if (background === 'plate') {
      tx = (lx - 805 / 0.257 / 18) * (0.257) - 2
      ty = (ly + 8345 / -0.252 / 115) * (-0.252) + 2 
    } else {
      tx = lx * (1.256) - 37700 / 95 - 5
      ty = ly * (-1.2685) + 237000 / 473 + 5
    }

    return [tx, ty]
  }

  const handleOnMouseDown = (e) => {
    const Bound = e.target.getBoundingClientRect();
    let dx = e.clientX - Bound.x
    let dy = e.clientY - Bound.y
    setX(`${dx-pointSize/2}px`)
    setY(`${dy-pointSize/2}px`)
    let tarr = markerLoc2StandardLoc(dx, dy)
    // console.log(tarr[0], tarr[1])
    handleOnChange(tarr)
    setHidden(false)
  }
  const styleConfig = {
    background: `url(${bkg})`, 
    backgroundRepeat: 'no-repeat', 
    backgroundSize: '100% 100%',
    
    width: `${width}px`,
    height: `${height}px`
  }
  return (
    <div className="point-marker-wrap" style={styleConfig} onMouseDown={handleOnMouseDown}>
      <Point top={y} left={x} hidden={hidden} radius={pointSize} color={dotColor}/>
    </div>
  )
}